import scrollService from '../services.common/scrollService';
import ClassAddRemove from '../utils.common/classAddRemove';

const RECIPIENT_LIST_NAME = 'recipient-list';
const SCROLL_BUTTON_SHOW_CLASS = 'active';

export default class RecipientList extends HTMLUListElement {
    connectedCallback() {
        this._handleObserveEvent = this._handleObserveEvent.bind(this);
        this._handleScroll = this._handleScroll.bind(this);

        this._observer = new MutationObserver(this._handleObserveEvent);
        this._observer.observe(this, { childList: true });
        this._scrollButton = document.querySelector(`[data-${RECIPIENT_LIST_NAME}-scroll-button]`);

        this._scrollButton.addEventListener("click", this._handleButtonClick);
    }

    disconnectedCallback() {
        this._observer.disconnect();
    }

    _handleObserveEvent(mutationsList) {
        try {
            let childAdded = false;
            let childRemoved = false;
            for(const mutation of mutationsList) {
                if (mutation.addedNodes.length > 0) {
                    childAdded = true;
                }

                if (mutation.removedNodes.length > 0) {
                    childRemoved = true;
                }

                if (childAdded && childRemoved) {
                    break;
                }
            }

            if (childAdded || childRemoved) {
                this._handleChildChange();
            }

            if (childAdded) {
                this._handleChildAdded();
            }
        } catch {}
    }

    _handleChildChange() {
        const children = this.children;
        if (children.length <= 3) {
            if (!this._scrollButton.hidden) {
                this._showHideButton(false);
            }
            
            scrollService.remove(this._handleScroll);
            return;
        }

        if (!this._scrollButton.hidden) {
            return;
        }

        scrollService.add(this._handleScroll);
        this._handleScroll();
    }

    _handleButtonClick(event) {
        event.preventDefault();
        window.scrollTo(0, 0);
    }

    _showHideButton(show = false) {
        this._scrollButton.hidden = !show;
        ClassAddRemove(this._scrollButton, SCROLL_BUTTON_SHOW_CLASS, show)
    }

    _handleScroll() {
        this._showHideButton(scrollService.getScrollPosition() > 0);
    }

    _handleChildAdded() {
        const children = this.children;
        for (var i = 0; i < children.length; i ++) {
            const inputs = children[i].querySelectorAll("input");
            let inputsBlank = 0;

            for (var j = 0; j < inputs.length; j ++) {
                if (inputs[j].value === "") {
                    inputsBlank += 1;
                }
            }

            if (inputs.length === inputsBlank) {
                inputs[0].focus();
                inputs[0].scrollIntoView({ behavior: "smooth", block: "center" });

                break;
            }
        }
    }
}

customElements.define(RECIPIENT_LIST_NAME, RecipientList, { extends: 'ul' });
